import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import {
  getForcedLanguage,
  getLanguageCode,
  hasUserSelectedLanguage,
} from "../utils/languageUtility";

const countryCodeToLanguage: Record<string, string> = {
  US: "en",
  GB: "en",
  CA: "en",
  AU: "en",
  NZ: "en",
  FR: "fr",
  BE: "fr",
  CH: "fr",
  DE: "de",
  AT: "de",
  IT: "it",
  ES: "es",
  MX: "es",
  AR: "es",
  SA: "ar",
  AE: "ar",
  CN: "zh",
  TW: "zh",
  PT: "pt",
  BR: "pt",
  RU: "ru",
  JP: "ja",
};

/** The language of the owner's country, else English. */
export const languageOfCountry = (countryCode?: string | null): string =>
  (countryCode && countryCodeToLanguage[countryCode.toUpperCase()]) || "en";

interface ProcessData {
  entity_data?: {
    owner_data?: {
      user_country_code?: string;
    };
  };
}

export const useLanguageDetection = (processData?: ProcessData | null) => {
  const { i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const forcedLanguage = getForcedLanguage(searchParams);

  useEffect(() => {
    if (!processData) return;

    if (forcedLanguage) return;

    if (hasUserSelectedLanguage()) return;

    const ownerLanguage = languageOfCountry(
      processData?.entity_data?.owner_data?.user_country_code
    );

    if (getLanguageCode(i18n.language) !== ownerLanguage) {
      void i18n.changeLanguage(ownerLanguage);
    }
  }, [processData, i18n, forcedLanguage]);
};
